"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigErrorMessage = void 0;

var _react = _interopRequireWildcard(require("react"));

var _basis = require("basis");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// @ts-ignore
var ConfigErrorMessage = function ConfigErrorMessage(props) {
  var errorMessages = props.errorMessages,
      isProduction = props.isProduction;
  (0, _react.useEffect)(function () {
    var message = 'Error: FiConnect component has not been configured correctly' + '\n' + "".concat(errorMessages.reduce(function (acc, item) {
      return "".concat(acc ? acc + '\n' : '', "- ").concat(item);
    }, '')) + '\n' + 'Please consult the FiConnect documentation for more information' + '\n' + 'https://github.com/LatitudeFinancial/fi-connect';
    console.error(message);
  }, [errorMessages]);

  if (isProduction) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_basis.Message, {
    severity: "warning-or-significant",
    bg: "secondary.pink.t30",
    testId: "config-error-message"
  }, "FiConnect component has not been configured correctly", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), errorMessages.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "item-".concat(index)
    }, item, /*#__PURE__*/_react.default.createElement("br", null));
  }), /*#__PURE__*/_react.default.createElement("br", null), "Please consult the FiConnect", ' ', /*#__PURE__*/_react.default.createElement(_basis.Link, {
    href: "https://github.com/LatitudeFinancial/fi-connect",
    newTab: true
  }, "documentation"), ' ', "for more information");
};

exports.ConfigErrorMessage = ConfigErrorMessage;